/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Badge, Button, ErrorText, PageHeader, Spinner } from '@/components/ui';
import { api } from '@/lib/api';

/** Б-2: администратор решает, можно ли передавать данные во внешний ИИ; маскирование персональных данных. */
export function AiPolicyPage() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['ai-policy'], queryFn: () => api.get('/admin/ai-policy') });
  const save = useMutation({ mutationFn: (b: any) => api.put('/admin/ai-policy', b), onSuccess: () => qc.invalidateQueries({ queryKey: ['ai-policy'] }) });
  if (!data) return <Spinner />;
  const st = data.status;
  return (
    <>
      <PageHeader title="ИИ и данные" subtitle="Куда уходят данные при работе ИИ-функций" />
      <div className="card mb-4 p-4 text-sm">
        <div className="mb-2">Подключённая модель: <b>{st.enabled ? `${st.provider} / ${st.model}` : 'не настроена'}</b> {st.enabled && (st.local ? <Badge tone="green">локальная</Badge> : <Badge tone="amber">внешний сервис</Badge>)}</div>
        <div className="text-slate-500">Модель и ключи задаются в файле data\settings.env. Локальная модель работает на вашем сервере, данные никуда не передаются.</div>
      </div>
      <div className="card space-y-4 p-4">
        <label className="flex items-start gap-3">
          <input type="radio" checked={data.mode === 'local'} onChange={() => save.mutate({ mode: 'local', mask: data.mask })} className="mt-1" />
          <span><b>Только локально</b><br /><span className="text-sm text-slate-500">ИИ-функции работают только с локальной моделью. Обращения к внешним сервисам блокируются.</span></span>
        </label>
        <label className="flex items-start gap-3">
          <input type="radio" checked={data.mode === 'external'} onChange={() => { if (confirm('Тексты запросов, фрагменты документов и карточек будут передаваться внешнему поставщику ИИ (оператору). Это передача персональных данных третьему лицу: нужны согласия субъектов или иное основание по 152-ФЗ и договор с поставщиком. Разрешить?')) save.mutate({ mode: 'external', mask: data.mask }); }} className="mt-1" />
          <span><b>Разрешить внешний ИИ</b> (GigaChat, YandexGPT и другие российские сервисы по договору лицензиата)<br /><span className="text-sm text-slate-500">Решение принимает администратор лицензиата, оно записывается в журнал аудита.</span></span>
        </label>
        <label className="flex items-center gap-3 border-t border-slate-100 pt-3">
          <input type="checkbox" checked={data.mask} onChange={(e) => save.mutate({ mode: data.mode, mask: e.target.checked })} />
          <span>Скрывать перед отправкой телефоны, e-mail, СНИЛС, паспорта, номера карт и счетов</span>
        </label>
        <ErrorText error={save.error} />
        {save.isPending && <span className="text-sm text-slate-500">Сохраняю...</span>}
        <div><Button variant="secondary" size="sm" onClick={() => qc.invalidateQueries({ queryKey: ['ai-policy'] })}>Обновить</Button></div>
      </div>
    </>
  );
}
